import { Controller } from "@hotwired/stimulus"

// Öffnet das Bootstrap-Modal sobald es per Turbo Stream in #ble_firmware_modal eingefügt wird,
// und räumt Backdrop/Body-Klassen auf, wenn der Stream das Element wieder entfernt.
export default class extends Controller {
  connect() {
    this.modal = new window.bootstrap.Modal(this.element, { backdrop: "static", keyboard: false })
    this.modal.show()
  }

  disconnect() {
    this.modal?.dispose()
    document.querySelectorAll(".modal-backdrop").forEach((el) => el.remove())
    document.body.classList.remove("modal-open")
    document.body.style.removeProperty("overflow")
    document.body.style.removeProperty("padding-right")
  }
}
